var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-6 px-4 px-md-0"},[_c('PolicyPrismic',{class:{ 'pt-1': !_vm.hideBanner, 'pt-4': _vm.hideBanner }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }